angular.module('app')
    .directive('animatedCaseStudy', animateCaseStudy)
function animateCaseStudy() {
    return {
        restrict: 'E',
        require: {
            scrollableContents: '^^scrollableContents',
            scrollableItem: '^^scrollableItem'
        },
        link: link
    }


    function link(scope, element, attrs, ctrl) {
        scope.peepsActive = false;
        const container = angular.element(element);
        const isMobile = ctrl.scrollableContents.isMobile;
        const caseStudiesFeedObj = container.find('.case-studies-feed');
        const button = container.find('.button-peep-stats');

        let tweenCaseStudy = null;
        function animate() {
            const xLargeText = container.find('.xlarge-text');
            const logoImg = container.find('.image-container');
            const logoSlogan = container.find('.logo-slogan');
            const introText = container.find('.intro-text');
            const logoCircle = container.find('.logo-circle');
            const pageStatuses = container.find('.page-statuses > ul > li');
            const bottomText = container.find('.bottom-text');

            if (!isMobile) {
                tweenCaseStudy = new TimelineMax()
                    //.set(pageStatuses, { opacity: 0, display: 'none' })
                    .set(caseStudiesFeedObj, { right: '-100%', display: 'none', opacity: 0 })
                    .set(xLargeText, { display: 'none', opacity: 0 })
                    .set(introText, { display: 'none', opacity: 0 })
                    .set(bottomText, { display: 'none', opacity: 0 })
                    .to(logoImg, 0.75, { startAt: { scale: 0 }, scale: 1, opacity: 1, ease: Bounce.easeInOut })
                    .to(logoSlogan, 0.75, { startAt: { scale: 3 }, scale: 1, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.5')
                    //.to(logoSlogan, 1, { rotation: 100, ease: Power2.easeInOut }, '-=0.5')
                    .to(logoCircle, 0.75, { boxShadow: '0px 0px 25px 25px rgb(255,255,255, 0.1)', repeat: -1, yoyo: true, ease: Linear.easeNone }, 1)
                    //.to(logoSlogan, 4, { startAt: { scaleX:5, scaleY:5, alpha:0 }, scaleX: 1, scaleY: 1, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.5')
                    .to(xLargeText, 0.75, { x: 0, startAt: { x: +350 }, display: 'block', opacity: 1, ease: Power2.easeInOut }, 0.5)
                    .to(introText, 0.75, { x: 0, startAt: { x: -50 }, display: 'block', opacity: 1, ease: Power2.easeInOut }, 0.75, "-=0.1")
                    .to(bottomText, 0.75, { y: 0, startAt: { y: +40 }, display: 'block', opacity: 1, ease: Expo.easeOut, onComplete: tweenOnComplete }, 0.75, "-=0.1")
                    .to(button, 0.5, { opacity: 1, ease: Expo.easeOut }, 1.5, "-=0.1")
                    //.to(logoSlogan, 0.75, { boxShadow: '0px 0px 20px 8px rgb(0,255,0)', repeat: -1, yoyo: true, ease: Linear.easeNone });
            }
            else {
                tweenCaseStudy = new TimelineMax()
                    .set(button, { opacity: 0 })
                    .set(caseStudiesFeedObj, { right: '-100%', display: 'none', opacity: 0 })
                    .set(xLargeText, { display: 'none', opacity: 0 })
                    .set(introText, { display: 'none', opacity: 0 })
                    .set(bottomText, { display: 'none', opacity: 0 })
                    .to(xLargeText, 0.75, { y: 0, startAt: { y: -100 }, display: 'block', opacity: 1, ease: Power2.easeInOut }, "-=0.5")
                    .to(introText, 0.75, { y: 0, startAt: { y: -150 }, display: 'block', opacity: 1, ease: Power2.easeInOut }, "-=0.25")
                    .to(bottomText, 0.75, { y: 0, startAt: { y: -150 }, display: 'block', opacity: 1, ease: Expo.easeOut }, "-=0.25")
                    .to(button, 0.5, { opacity: 1, ease: Expo.easeOut, onComplete: tweenOnComplete }, "-=0.25")
            }
        }

        function tweenOnComplete() {
            if (parseInt(ctrl.scrollableItem.contentIndex) === parseInt(ctrl.scrollableContents.totalSections)) {
                ctrl.scrollableContents.setArrowVisibility(false);
                ctrl.scrollableContents.setFooterVisibility(true);
            } else {
                ctrl.scrollableContents.setArrowVisibility(true);
            }
        }

        function createServiceFlowLineTween(serviceFlows, serviceFlowLines) {
            const tween = new TimelineMax();
            for (var indx = 0; indx < serviceFlowLines.length; indx++) {
                tween.from(serviceFlowLines[indx], 1, { opacity: 0, width: 0, ease: Power3.easeIn }, '-=0.5')
                    .to(serviceFlows[(indx + 1) == serviceFlowLines.length ? 0 : indx + 1], 0.15,
                        { autoAlpha: 0.4, yoyo: true, repeat: 1 })
            }

            return tween;
        }

        function createServiceFlowCircleTween(serviceFlows, serviceFlowBoxes, serviceFlowCircles) {
            const tween = new TimelineMax({ repeat: -1, repeatDelay: -0.25 });
            for (var indx = 0; indx < serviceFlowCircles.length; indx++) {
                tween.to(serviceFlowCircles[indx], 0.5, { opacity: 0.5, ease: Power3.easeIn })
                    .to(serviceFlowCircles[indx], 1, { startAt: { x: -20 }, x: angular.element(serviceFlowBoxes[indx]).width(), opacity: 0, display: 'none', ease: Power3.easeIn }, '-=0.75')
                    .to(serviceFlows[(indx + 1) == serviceFlowCircles.length ? 0 : indx + 1], 0.25,
                        { autoAlpha: 0.4, yoyo: true, repeat: 1 })
            }
            return tween;
        }

        //button peep stats click event
        scope.peepsActive = false;
        container.find('.button-peep-stats')
            .on('click', function () {
                const descriptionObj = container.find('.description');
                const xLargeText = container.find('.xlarge-text');
                if (!scope.peepsActive) {
                    if (!isMobile) {
                        angular.element(this).addClass('active');
                        new TimelineMax()
                            .to(descriptionObj, 0.5, { display: 'none', opacity: 0, ease: Power2.easeOut })
                            .to(caseStudiesFeedObj, 1, { right: '4%', opacity: 1, display: 'block', ease: Power2.easeInOut }, "-=1")
                    }
                    else {
                        new TimelineMax()
                            .to(xLargeText, 0.75, { y: -100, opacity: 0, display: 'none', ease: Power2.easeInOut })
                            .to(descriptionObj, 0.5, { display: 'none', opacity: 0, ease: Power2.easeOut }, '-=0.75')
                            .to(button, 1, { y: -(container.height() - 200), ease: Elastic.easeOut }, '-=0.25')
                            .to(caseStudiesFeedObj, 0.5, { right: '0', display: 'block', opacity: 1, ease: Power2.easeInOut }, "-=1")
                            .eventCallback('onComplete', setPeepsStatus);
                    }

                } else {
                    //
                    if (!isMobile) {
                        angular.element(this).removeClass('active');
                        new TimelineMax()
                            .to(caseStudiesFeedObj, 0.5, { right: '-100%', opacity: 0, ease: Power2.easeInOut })
                            .to(descriptionObj, 1, { display: 'inline-block', opacity: 1, ease: Power2.easeIn }, "-=1");
                    }
                    else {
                        new TimelineMax()
                            .to(caseStudiesFeedObj, 0.5, { right: '-100%', display: 'none', opacity: 0, ease: Power2.easeInOut })
                            .to(button, 1, { y: 0, ease: Elastic.easeOut })
                            .to(xLargeText, 0.5, { y: 0, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.75')
                            .to(descriptionObj, 0.75, { display: 'block', opacity: 1, ease: Power2.easeOut }, '-=0.5')
                            .eventCallback('onComplete', setPeepsStatus);

                    }
                }
                
                scope.peepsActive = !scope.peepsActive;
                function setPeepsStatus() {
                    const peepsBtn = container.find('.button-peep-stats');
                    console.log('setPeepsStatus', peepsBtn);
                    if (peepsBtn.hasClass('active')) {
                        peepsBtn.removeClass('active');
                    }
                    else {
                        peepsBtn.addClass('active');
                    }
                }
        });

        container.find('.img-container').on('mouseenter', function (event) {
            const element = angular.element(event.srcElement || event.target);
            const caseStudyItemContainer = element.closest('.case-study-item');
            const imgContainer = caseStudyItemContainer.find('.img-container');
            const clientLogo = imgContainer.find('.client-logo');
            const pageStatusItemLine = caseStudyItemContainer.find('.page-statuses > ul > li > span.status-line');

            new TimelineMax()
                .to(clientLogo, 0.5, { backgroundColor: 'rgba(255, 255, 255, 0.7)', opacity: 1, ease: Power4.easeInOut })
                //.add(pageStatusTween(caseStudyItemContainer))
                //.staggerTo(pageStatusList, 0.5, { y: 0, startAt: { y: -100 }, opacity: 1, display: 'block', ease: Power4.easeIn }, -0.05, '-=0.5')
                //.staggerTo(pageStatusItemLine, 0.25, { width: '100%', ease: Power2.easeIn }, -0.05, '-=0.25')
                //.to(pageStatus, 0.5, { y: 0, opacity: 1, display: 'block', ease: Power2.easeInOut }, '-=0.5')
        }).on('mouseleave', function (event) {
            const element = angular.element(event.srcElement || event.target);
            const caseStudyItemContainer = element.closest('.case-study-item');
            //const pageStatus = caseStudyItemContainer.find('.page-statuses');
            const pageStatusList = caseStudyItemContainer.find('.page-statuses > ul > li');
            const imgContainer = caseStudyItemContainer.find('.img-container');
            const clientLogo = imgContainer.find('.client-logo');
            const pageStatusItemLine = caseStudyItemContainer.find('.page-statuses > ul > li > span.status-line');

            new TimelineMax()
                .to(clientLogo, 0.5, { backgroundColor: 'transparent', opacity: 0, ease: Power4.easeInOut })
                //.staggerTo(pageStatusList, 0.25, { y: -100, opacity: 0, display: 'none', ease: Power2.easeInOut }, 0.05, '-=0.5')
                //.staggerTo(pageStatusItemLine, 0.25, { width:0, ease: Power4.easeIn }, -0.05, '-=0.7')
                //.staggerTo(pageStatusItemLine, 0.25, { x:-100, ease: Power4.easeIn }, -0.05, '-=0.7')
                //.to(pageStatus, 0.5, { opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.5')
                //.to(pageStatus, 0.5, { y: -100, opacity: 0, display: 'none', ease: Power2.easeInOut }, '-=0.5')
        })

        function pageStatusTween(container) {
            const pageStatusList = container.find('.page-statuses > ul > li');
            const tweenPageStatus = new TimelineMax();
            for (let i = 0; i <= pageStatusList.length - 1; i++) {
                const item = angular.element(pageStatusList[i]);
                const line = item.find('.status-line');
                tweenPageStatus
                    .to(item, 0.2, { y: 0, startAt: { y: -100 }, opacity: 1, display: 'block', ease: Power4.easeInOut }, '-=0.35')
                    .to(line, 0.5, { width: '100%', ease: Power2.easeInOut }, '-=0.25')
            }
        }

        scope.$on('animate', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenCaseStudy) {
                    tweenCaseStudy.time(0).restart();
                }
                else {
                    animate();
                }
            }
        })

        scope.$on('pauseAnimation', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenCaseStudy) {
                    tweenCaseStudy.pause();
                }
            }
        })
    }
}